import { Outlet, Link, useLocation } from 'react-router-dom'
import { Shield, Github } from 'lucide-react'
import styles from './Layout.module.css'

export default function Layout() {
  const location = useLocation()
  const isHome = location.pathname === '/'

  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <Link to="/" className={styles.logo}>
            <Shield className={styles.logoIcon} />
            <span className={styles.logoText}>JAR</span>
            <span className={styles.logoAccent}>Scanner</span>
          </Link>

          <nav className={styles.nav}>
            <span className={styles.navBadge}>
              Napędzany AI • Kimi K3 • Llama 3.2 90B
            </span>
          </nav>

          <div className={styles.headerActions}>
            <a
              href="https://github.com"
              target="_blank"
              rel="noreferrer"
              className={styles.iconBtn}
              aria-label="GitHub"
            >
              <Github size={18} />
            </a>
          </div>
        </div>
      </header>

      {isHome && (
        <div className={styles.hero}>
          <div className={styles.heroInner}>
            <div className={styles.heroBadge}>
              <span className={styles.heroBadgeDot} />
              Napędzany przez NVIDIA NIM API
            </div>
            <h1 className={styles.heroTitle}>
              Wykrywaj złośliwy kod w{' '}
              <span className={styles.heroAccent}>plikach Java</span>
            </h1>
            <p className={styles.heroSubtitle}>
              Wgraj dowolny plik .jar i otrzymaj szczegółowy raport bezpieczeństwa — backdoory,
              kryptominery, obfuskacja, eksfiltracja danych i wiele więcej.
            </p>
          </div>
        </div>
      )}

      <main className={styles.main}>
        <div className={styles.mainInner}>
          <Outlet />
        </div>
      </main>

      <footer className={styles.footer}>
        <div className={styles.footerInner}>
          <span>JAR Scanner &copy; 2026</span>
          <span className={styles.footerDivider}>•</span>
          <span>Napędzany przez NVIDIA Build API</span>
          <span className={styles.footerDivider}>•</span>
          <a href="https://jarscanner.pages.dev">jarscanner.pages.dev</a>
        </div>
      </footer>
    </div>
  )
}
